import { call, put, takeLatest } from "redux-saga/effects";
import Module from "../../modules/circle/new";
import "babel-polyfill";
import axios from "../axios";

// eslint-disable-next-line no-unused-vars
function* createNewCircle(action) {
  try {
    const result = yield call(
      function(circle) {
        const body = JSON.stringify({
          name: circle.name,
          company_id: circle.company_id,
          type: circle.type,
        });
        return axios
          .post("/api/circles/create_new_circle", body)
          .then((response) => response.data)
          .catch(() => false);
    }, action.payload.circle);

    if (result) {
      let circle = action.payload.circle;
      circle["id"] = result.circle_id;
      circle["name"] = result.circle_name;
      circle['pref_id'] = result.pref_id;
      circle["type"] = result.circle_type; 
      yield put(
        Module.actions.createSuccess({
          modalIsOpen: true,
          createStatus: "success",
          circleId: result.circle_id,
          circle: circle,
        })
      );
    } else {
      yield put(
        Module.actions.createFailure({
          modalIsOpen: true,
          createStatus: "error",
        })
      );
    }
  } catch (e) {
    yield put(Module.actions.createFailure({ createStatus: "error" }));
  }
}

function* createCategory(action) {
  try {
    const result = yield call(
      function(circleId, category) {
        let formData = new FormData();
        formData.append("id", circleId);
        formData.append("category", category);
        return axios
          .post("/api/circle/create_circles_category", formData)
          .then((response) => response.data)
          .catch(() => false);
      },
      action.payload.circleId,
      action.payload.category
    );
    if (result) {
      yield put(
        Module.actions.createCategorySuccess({
          createCategoryStatus: "success",
        })
      );
    } else {
      yield put(
        Module.actions.createCategoryFailure({
          createCategoryStatus: "error",
        })
      );
    }
  } catch (e) {
    yield put(
      Module.actions.createCategoryFailure({ createCategoryStatus: "error" })
    );
  }
}

function* createOshikatsuGenre(action) {
  try {
    const result = yield call(function(circleId, service) {
      let formData = new FormData();
      formData.append("id", circleId);
      formData.append("service", service);
      return axios
        .post("/api/circle/create_oshikatsu_genre", formData)
        .then((response) => response.data)
        .catch(() => false);
    }, action.payload.circleId, action.payload.service);
    if (result) {
      yield put(Module.actions.createOshikatsuGenreSuccess
        ({createOshikatsuGenreStatus: "success",
          circleList: result.circleList
        }));
    } else {
      yield put(Module.actions.createOshikatsuGenreFailure({createOshikatsuGenreStatus: "error"}));
    }
  } catch (e) {
    yield put(Module.actions.createOshikatsuGenreFailure({createOshikatsuGenreStatus: "error"}));
    console.error("[createOshikatsuGenre] Saga error:", e);
  }
}

function* updateCircle(action) {
  try {
    const result = yield call(function(circle) {
      const body = JSON.stringify(circle);
      return axios
        .post("/api/circles/update", body)
        .then((response) => response.status === 200)
        .catch(() => false);
    }, action.payload.circle);
    if (result) {
      if (action.payload.isSubmit) {
        yield put(
          Module.actions.submitSuccess({
            submitStatus: "success",
            modalIsOpen: true,
          })
        );
      }
    } else {
      if (action.payload.isSubmit) {
        yield put(
          Module.actions.submitError({
            submitStatus: "error",
            modalIsOpen: true,
          })
        );
      }
    }
  } catch (e) {
    if (action.payload.isSubmit) {
      yield put(
        Module.actions.submitError({
          submitStatus: "error",
          modalIsOpen: true,
        })
      );
    }
  }
}

function* updateCircleTag(action) {
  try {
    const result = yield call(function(circle) {
      const body = JSON.stringify(circle);
      return axios
        .post("/api/circles/tags/update", body)
        .then((response) => response.status === 200)
        .catch(() => false);
    }, action.payload.circle);
    if (result) {
      if (action.payload.isSubmit) {
        yield put(
          Module.actions.submitSuccess({
            submitStatus: "success",
            modalIsOpen: true,
          })
        );
      }
    } else {
      if (action.payload.isSubmit) {
        yield put(
          Module.actions.submitError({
            submitStatus: "error",
            modalIsOpen: true,
          })
        );
      }
    }
  } catch (e) {
    if (action.payload.isSubmit) {
      yield put(
        Module.actions.submitError({
          submitStatus: "error",
          modalIsOpen: true,
        })
      );
    }
  }
}

/**
 * メイン画像登録
 */
function* uploadCircleImage(action) {
  try {
    const result = yield call(
      function(circle, file) {
        let formData = new FormData();
        formData.append("id", circle.id);
        formData.append("file", file);
        return axios
          .post("/api/circle/upload_circle_image", formData)
          .then((response) => response.data)
          .catch(() => false);
      },
      action.payload.circle,
      action.payload.file
    );
    if (result) {
      let circle = action.payload.circle;
      circle["main_image_url"] = result.main_image_url;
      yield put(
        Module.actions.uploadCircleImageSuccess({
          mainImageUrl: result.main_image_url,
          circle: circle,
          imageUploadStatus: "success",
        })
      );
    } else {
      yield put(
        Module.actions.uploadCircleImageFailure({
          imageUploadStatus: "error",
        })
      );
    }
  } catch (e) {
    yield put(
      Module.actions.uploadCircleImageFailure({
        imageUploadStatus: "error",
      })
    );
  }
}

function* createRelation(action) {
  try {
    const { parent_id, child_id } = action.payload;
    const formData = new FormData();
    formData.append('parent_id', parent_id);
    formData.append('child_id', child_id);

    const response = yield call(() =>
      axios.post('/api/circle/create_relation', formData)
    );
    if (response.status === 200) {
      yield put(
        Module.actions.createRelationSuccess({
          parentCircleId: parent_id,
        })
      );
    } else {
      yield put(
        Module.actions.createRelationFailure({ error: 'create_relation failed' })
      );
    }
  } catch (err) {
    yield put(
      Module.actions.createRelationFailure({ error: err.message })
    );
  }
}
function* getOshikatsuData(action) {
  try {
    const circleId = action.payload.circleId; // 53358
    const res = yield call(() =>
      axios.post("/api/circles/get_oshikatsu_data", { circle_id: circleId })
    );
    if (res.data.success) {
      yield put(Module.actions.getOshikatsuDataSuccess({
        servicesCircles: res.data.servicesCircles,
        circlesRelations: res.data.circlesRelations,
        circleList: res.data.circleList,
      }));
    } else {
      yield put(Module.actions.getOshikatsuDataFailure());
    }
  } catch (e) {
    yield put(Module.actions.getOshikatsuDataFailure());
  }
}

export default function*() {
  yield takeLatest(Module.actions.createNewCircle, createNewCircle);

  yield takeLatest(Module.actions.createCategory, createCategory);

  yield takeLatest(Module.actions.updateCircle, updateCircle);

  yield takeLatest(Module.actions.updateCircleTag, updateCircleTag);

  yield takeLatest(Module.actions.uploadCircleImage, uploadCircleImage);

  yield takeLatest(Module.actions.createOshikatsuGenre, createOshikatsuGenre);

  yield takeLatest(Module.actions.createRelation, createRelation);

  yield takeLatest(Module.actions.getOshikatsuData, getOshikatsuData);
}
